function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { rem } from '../../functions/units';

// eslint-disable-next-line complexity, sonarjs/cyclomatic-complexity
var _ref = process.env.NODE_ENV === "production" ? {
  name: "eivff4",
  styles: "display:none"
} : {
  name: "oa0wgj-normalize",
  styles: "display:none;label:normalize;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "6mmdai",
  styles: "display:list-item"
} : {
  name: "mlntgp-normalize",
  styles: "display:list-item;label:normalize;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref3 = process.env.NODE_ENV === "production" ? {
  name: "1yq3syn",
  styles: "vertical-align:baseline"
} : {
  name: "mdclxw-normalize",
  styles: "vertical-align:baseline;label:normalize;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref4 = process.env.NODE_ENV === "production" ? {
  name: "m9z93z",
  styles: "box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal"
} : {
  name: "13mqtq7-normalize",
  styles: "box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal;label:normalize;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref5 = process.env.NODE_ENV === "production" ? {
  name: "wt1ptd",
  styles: "padding:0.35em 0.75em 0.625em"
} : {
  name: "1dlh85j-normalize",
  styles: "padding:0.35em 0.75em 0.625em;label:normalize;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref6 = process.env.NODE_ENV === "production" ? {
  name: "1bw1d49",
  styles: "font-family:inherit;font-size:100%;line-height:1.15;margin:0;overflow:auto"
} : {
  name: "1dnh1yi-normalize",
  styles: "font-family:inherit;font-size:100%;line-height:1.15;margin:0;overflow:auto;label:normalize;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref7 = process.env.NODE_ENV === "production" ? {
  name: "1b8dtnc",
  styles: "font-family:inherit;font-size:100%;line-height:1.15;margin:0;text-transform:none"
} : {
  name: "y84ybr-normalize",
  styles: "font-family:inherit;font-size:100%;line-height:1.15;margin:0;text-transform:none;label:normalize;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref8 = process.env.NODE_ENV === "production" ? {
  name: "19f067o",
  styles: "font-family:inherit;font-size:100%;line-height:1.15;margin:0"
} : {
  name: "12qzd0g-normalize",
  styles: "font-family:inherit;font-size:100%;line-height:1.15;margin:0;label:normalize;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref9 = process.env.NODE_ENV === "production" ? {
  name: "1x2gl8m",
  styles: "font-family:inherit;font-size:100%;line-height:1.15;margin:0;overflow:visible"
} : {
  name: "3yjwlc-normalize",
  styles: "font-family:inherit;font-size:100%;line-height:1.15;margin:0;overflow:visible;label:normalize;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref10 = process.env.NODE_ENV === "production" ? {
  name: "akddj4",
  styles: "font-size:75%;line-height:0;position:relative;vertical-align:baseline;top:-0.5em"
} : {
  name: "nysk02-normalize",
  styles: "font-size:75%;line-height:0;position:relative;vertical-align:baseline;top:-0.5em;label:normalize;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref11 = process.env.NODE_ENV === "production" ? {
  name: "yxef7",
  styles: "font-size:75%;line-height:0;position:relative;vertical-align:baseline;bottom:-0.25em"
} : {
  name: "10v1dkm-normalize",
  styles: "font-size:75%;line-height:0;position:relative;vertical-align:baseline;bottom:-0.25em;label:normalize;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref12 = process.env.NODE_ENV === "production" ? {
  name: "1ew8yt4",
  styles: "font-size:80%"
} : {
  name: "jhph2u-normalize",
  styles: "font-size:80%;label:normalize;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref13 = process.env.NODE_ENV === "production" ? {
  name: "d3kzo8",
  styles: "font-weight:bolder"
} : {
  name: "1ab71e9-normalize",
  styles: "font-weight:bolder;label:normalize;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref14 = process.env.NODE_ENV === "production" ? {
  name: "1s32kii",
  styles: "border-bottom:none;text-decoration:underline;text-decoration:underline dotted"
} : {
  name: "107k1va-normalize",
  styles: "border-bottom:none;text-decoration:underline;text-decoration:underline dotted;label:normalize;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref15 = process.env.NODE_ENV === "production" ? {
  name: "14m2ziy",
  styles: "font-family:monospace;font-size:1em"
} : {
  name: "9j0g6a-normalize",
  styles: "font-family:monospace;font-size:1em;label:normalize;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref16 = process.env.NODE_ENV === "production" ? {
  name: "1ownu17",
  styles: "box-sizing:content-box;height:0;overflow:visible"
} : {
  name: "5wues5-normalize",
  styles: "box-sizing:content-box;height:0;overflow:visible;label:normalize;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref17 = process.env.NODE_ENV === "production" ? {
  name: "2mgdh6",
  styles: "font-size:2em;margin:0.67em 0"
} : {
  name: "1irh2ex-normalize",
  styles: "font-size:2em;margin:0.67em 0;label:normalize;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref18 = process.env.NODE_ENV === "production" ? {
  name: "4zleql",
  styles: "display:block"
} : {
  name: "jd9f1z-normalize",
  styles: "display:block;label:normalize;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var normalize = function normalize(el) {
  switch (el) {
    case 'main':
    case 'details':
      {
        return _ref18;
      }
    case 'h1':
      {
        return _ref17;
      }
    case 'hr':
      {
        return _ref16;
      }
    case 'pre':
    case 'code':
    case 'kbd':
    case 'samp':
      {
        return _ref15;
      }
    case 'abbr[title]':
      {
        return _ref14;
      }
    case 'b':
    case 'strong':
      {
        return _ref13;
      }
    case 'small':
      {
        return _ref12;
      }
    case 'sub':
      {
        return _ref11;
      }
    case 'sup':
      {
        return _ref10;
      }
    case 'button':
      {
        return /*#__PURE__*/css("font-family:inherit;font-size:100%;line-height:1.15;margin:0;overflow:visible;text-transform:none;-webkit-appearance:button;&::-moz-focus-inner{border-style:none;padding:0;}&:-moz-focusring{outline:", rem(1), " dotted ButtonText;}" + (process.env.NODE_ENV === "production" ? "" : ";label:normalize;"));
      }
    case 'input':
      {
        return _ref9;
      }
    case 'optgroup':
      {
        return _ref8;
      }
    case 'select':
      {
        return _ref7;
      }
    case 'textarea':
      {
        return _ref6;
      }
    case 'fieldset':
      {
        return _ref5;
      }
    case 'legend':
      {
        return _ref4;
      }
    case 'progress':
      {
        return _ref3;
      }
    case 'summary':
      {
        return _ref2;
      }
    case 'template':
      {
        return _ref;
      }
  }
};
export default normalize;